import React, { Component } from 'react';
import { Icon, Modal } from 'antd';

class Modalshortfalls extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {}

  componentDidMount() {}

  render() {
    let { data } = this.props;
    const { visible, hideModal } = this.props;
    data = data.split('\n');
    return (
      <Modal
        title={
          <p style={{ margin: '0' }}>
            <Icon type="close-circle" style={{ color: 'red', marginRight: '10px' }} />
            预算不足！
          </p>
        }
        visible={visible}
        footer={null}
        onCancel={hideModal}
        width="40%"
      >
        <p style={{ fontSize: '14px' }}>请联系以下预算组负责人调整预算</p>
        <ul>
          {data
            ? data.map(item => {
                return <li key={item}>{item}</li>;
              })
            : null}
        </ul>
      </Modal>
    );
  }
}

export default Modalshortfalls;



// WEBPACK FOOTER //
// ./src/components/comm/shortfalls/index.js